"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApmInterval = exports.ApmTimeRange = exports.ApmApiFields = exports.ApmApiMethods = void 0;
var ApmApiMethods;
(function (ApmApiMethods) {
    ApmApiMethods["EVENTS"] = "events";
    ApmApiMethods["EVENTS_META"] = "events-meta";
    ApmApiMethods["EVENT_STATS"] = "events-stats";
    ApmApiMethods["SESSIONS"] = "sessions";
    ApmApiMethods["RELEASES_STATS"] = "releases/stats";
    ApmApiMethods["RELEASE_VERSION_VALUES"] = "release.version/values";
    ApmApiMethods["ISSUES"] = "issues";
    ApmApiMethods["RECOMMENDED"] = "recommended";
    ApmApiMethods["ISSUE_EVENTS"] = "issue-events";
})(ApmApiMethods = exports.ApmApiMethods || (exports.ApmApiMethods = {}));
var ApmApiFields;
(function (ApmApiFields) {
    ApmApiFields["CRASH_FREE_RATE_SESSION"] = "crash_free_rate(session)";
    ApmApiFields["CRASH_FREE_RATE_USER"] = "crash_free_rate(user)";
    ApmApiFields["SUM_SESSION"] = "sum(session)";
    ApmApiFields["COUNT"] = "count()";
})(ApmApiFields = exports.ApmApiFields || (exports.ApmApiFields = {}));
var ApmTimeRange;
(function (ApmTimeRange) {
    ApmTimeRange["LAST_1_HOUR"] = "1h";
    ApmTimeRange["LAST_24_HOURS"] = "24h";
    ApmTimeRange["LAST_7_DAYS"] = "7d";
    ApmTimeRange["LAST_14_DAYS"] = "14d";
    ApmTimeRange["LAST_30_DAYS"] = "30d";
    ApmTimeRange["LAST_90_DAYS"] = "90d";
})(ApmTimeRange = exports.ApmTimeRange || (exports.ApmTimeRange = {}));
var ApmInterval;
(function (ApmInterval) {
    ApmInterval["ONE_MINUTE"] = "1m";
    ApmInterval["FIFTEEN_MINUTES"] = "15m";
    ApmInterval["ONE_HOUR"] = "1h";
    ApmInterval["TWO_HOURS"] = "2h";
    ApmInterval["SIX_HOURS"] = "6h";
    ApmInterval["TWELVE_HOURS"] = "12h";
    ApmInterval["ONE_DAY"] = "1d";
})(ApmInterval = exports.ApmInterval || (exports.ApmInterval = {}));
